import isTomorrow from './is-tomorrow';

export { isTomorrow };

export default isTomorrow;
